import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var validate = function validate(t) {
  return function (values, name, value) {
    var errors = {};
    var emailTest = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm;
    if (!values) {
      if (name === "name" && !value.trim()) {
        errors.name = t("validation_name_required");
      } else if (name === "name" && value.trim().length < 2) {
        errors.name = t("validation_full_name_2_characters");
      }
      if (name === "phone" && !value.trim()) {
        errors.phone = t("validation_mobile_number_required");
      } else if (name === "phone" && isNaN(value)) {
        errors.phone = t("numbers_allowed");
      } else if (name === "phone" && value.trim().length !== 10) {
        errors.phone = t("validation_number_10_digits");
      } else if (name === "phone" && !/^(05)[0-9]{8}$/.test(value)) {
        errors.phone = t("validation_mobile_number_start_05_2");
      }
      if (name === "email" && !value.trim()) {
        errors.email = t("validation_email_required");
      } else if (name === "email" && !emailTest.test(value)) {
        errors.email = t("validation_valid_email_address_entered");
      }
      if (name === "subject") {
        if (!value.trim()) {
          errors.subject = t("validation_message_subject_required");
        } else if (value.length > 40) {
          errors.subject = t("validation_message_subject_40_characters_fewer");
        }
      }
      if (name === "body" && !value.trim()) {
        errors.body = t("validation_message_text_required");
      } else if (name === "body" && value.trim().length < 10) {
        errors.body = t("validation_inquiry_subject_10_characters");
      }
    } else {
      if (!values.name.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          name: t("validation_name_required")
        });
      } else if (values.name.trim().length < 2) {
        errors.name = t("validation_full_name_2_characters");
      }
      if (!values.phone.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("validation_mobile_number_required")
        });
      } else if (values.phone.length !== 10) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("validation_number_10_digits")
        });
      } else if (isNaN(values.phone)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("numbers_allowed")
        });
      } else if (!/^(05)[0-9]{8}$/.test(values.phone)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          phone: t("validation_mobile_number_start_05_2")
        });
      }
      if (!values.email.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          email: t("validation_email_required")
        });
      } else if (!emailTest.test(values.email)) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          email: t("validation_valid_email_address_entered")
        });
      }
      if (!values.subject.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          subject: t("validation_message_subject_required")
        });
      } else if (values.subject.length > 40) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          subject: t("validation_message_subject_40_characters_fewer")
        });
      }
      if (!values.body.trim()) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          body: t("validation_message_text_required")
        });
      } else if (values.body.trim().length < 10) {
        errors = _objectSpread(_objectSpread({}, errors), {}, {
          body: t("validation_inquiry_subject_10_characters_2")
        });
      }
    }
    return errors;
  };
};
export default validate;